<template>
  <tk-flex
    column
    v-if="inviData"
    style="padding: 10px"
    :style="{ width: width * 2 + 'px', height: height * 2 + 'px' }"
  >
    <div :style="{ height: width * 2 + 'px' }" style="width: 100%">
      <tk-image
        :quality="100"
        style="width: 100%; height: 100%"
        :src="inviData.cover"
      ></tk-image>
    </div>
    <div :style="{ height: (height - width) * 2 + 'px' }" style="width: 100%">
      <tk-flex
        middle
        between
        style="width: 100%; height: 100%; padding-right: 40px"
      >
        <tk-flex
          between
          column
          style="height: 200px; padding: 30px 30px 0 30px"
        >
          <div class="line-clamp-2" style="font-size: 30px">
            {{ inviData.name }}
          </div>
          <div style="color: #fa6400; font-size: 24px">
            长按图片识别小程序码
          </div>
        </tk-flex>
        <div style="height: 200px; width: 200px">
          <tk-image
            style="height: 200px; width: 200px"
            :src="qrImage"
          ></tk-image>
        </div>
      </tk-flex>
    </div>
  </tk-flex>
</template>
<script>
export default {
  data () {
    return {
      width: 319,
      height: 450,
      getParams: [],
      qrImage: '',
      inviData: {
        inviImg: [],
        user: {
          avatar: '',
          nickName: ''
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    //   // 0 帖子数据id ，1 设备宽， 2设备高
  },
  methods: {
    async init () {
      // this.getParams = 'aPKRvheXXF'
      this.getParams = this.$route.query.params
      await this.getInvi() // 获取帖子数据
    },
    async getInvi () {
      // const res = await this.$tkParse.get(`https://cloud.zhituo.mokekeji.com/classes/invitation/${this.getParams[0]}`, { params: { include: 'user' } })
      // const res1 = await this.$axios.get(`https://cloud.zhonghui.mokekeji.com/wx/getWxacode?id=${this.getParams[0]}`, {
      //   responseType: 'arraybuffer'
      // })
      const res = await this.$tkParse.get(
        `https://cloud.zhonghui.mokekeji.com/classes/wares/${this.getParams}`
      )
      console.log(res)
      this.qrImage = res.data.QRcode
      // const res1 = await this.$axios.get(
      //   `https://cloud.zhonghui.mokekeji.com/user/getWxacode?id=${this.getParams}`,
      //   {
      //     responseType: 'arraybuffer'
      //   }
      // )
      // const base64String = `data:image/jpeg;base64,${window.btoa(
      //   String.fromCharCode(...new Uint8Array(res1.data))
      // )}`
      // this.qrImage = base64String
      this.inviData = res.data
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss" scoped>
.poster-text {
  font-size: 28px;
  margin-top: 24px;
}
// 只显示两行超出隐藏
.line-clamp-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
